import { ApolloClient } from 'apollo-client';
import { setContext } from 'apollo-link-context';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { createHttpLink } from 'apollo-link-http';
import { onError } from 'apollo-link-error';
import { ApolloLink } from 'apollo-link';
import { WebSocketLink } from 'apollo-link-ws';
import { SubscriptionClient } from 'subscriptions-transport-ws';
import { getMainDefinition } from 'apollo-utilities';

import { forEach } from 'lodash';

// import { SubscriptionClient, addGraphQLSubscriptions } from 'subscription-transport-ws';
import { getNetworkInfo } from '../util/network';

import Storage from '../util/storage';

import {
  onError as handleError,
  onReceiveCount,
  onReceiveHasMore,
} from '../modules/app_state/actions';

const {
  tp,
  tp_ws: ws,
  domain,
  endpoints: { nimbus: nep, subscription: sep },
} = getNetworkInfo();

/*
const authLink = setContext((_, { headers }) => Storage.getToken().then(token => Promise.resolve({
  headers: {
    ...headers,
    Authorization: token ? `Bearer ${token}` : '',
  },
})));
*/
const authLink = setContext((_, { headers }) => ({
  headers: {
    ...headers,
    Authorization: global.__token_nim ? `Bearer ${global.__token_nim}` : '',
  },
}));

const httpLink = createHttpLink({ uri: `${tp}${domain}${nep}` });

const subscriptionClient = new SubscriptionClient(`${ws}${domain}${sep}`, {
  reconnect: true,
  connectionParams: {}, // pass in user id here?
});

const webSocketLink = new WebSocketLink(subscriptionClient);

const requestLink = ({ link, wsLink }) =>
  ApolloLink.split(
    ({ query }) => {
      const { kind, operation } = getMainDefinition(query);
      return kind === 'OperationDefinition' && operation === 'subscription';
    },
    wsLink,
    link,
  );

const afterwareLink = (store) =>
  new ApolloLink((operation, forward) =>
    forward(operation).map((response) => {
      const context = operation.getContext();
      const {
        response: { headers },
      } = context;
      if (headers) {
        const count = headers.get('X-Total-Count');
        const hasMore = headers.get('Has-More');
        if (count) store.dispatch(onReceiveCount(count));
        if (hasMore) store.dispatch(onReceiveHasMore(hasMore));
      }
      return response;
    }),
  );

let cli;

export const createClient = (store) => {
  cli = new ApolloClient({
    link: ApolloLink.from([
      onError(({ graphQLErrors, networkError }) => {
        if (graphQLErrors) {
          forEach(graphQLErrors, ({ message, locations, path }) => {
            console.log(
              '[GraphQL error]',
              'Message: ',
              message,
              'Location: ',
              locations,
              'Path: ',
              path,
            );
            // TODO: add global error handler
            // window.persistor.purge()
          });
          store.dispatch(handleError(graphQLErrors[0]));
        }
        // TODO: perhaps log the user out?
        if (networkError) {
          console.log(`[Network error]: ${networkError}`);
          // window.persistor.purge();
        }
      }),
      requestLink({
        link: authLink.concat(afterwareLink(store)).concat(httpLink),
        wsLink: webSocketLink,
      }),
    ]),
    cache: new InMemoryCache({
      // addTypename: false,
      dataIdFromObject: (obj) => obj._id,
    }),
    defaultOptions: {
      watchQuery: {
        fetchPolicy: 'no-cache',
        errorPolicy: 'ignore',
      },
      query: {
        fetchPolicy: 'no-cache',
        errorPolicy: 'all',
      },
    },
  });
  return cli;
};

export const makeQuery =
  (variables = {}) =>
  (actionTypes, query) =>
  () => ({
    types: actionTypes,
    promise: async () => {
      const result = await cli.query({
        query,
        variables,
        fetchPolicy: 'no-cache',
      });
      return result.data;
    },
  });

export const makeMutation =
  ({ variables = {}, update = () => {}, refetchQueries = [] }) =>
  (actionTypes, mutation) =>
  () => ({
    types: actionTypes,
    promise: async () => {
      const result = await cli.mutate({
        mutation,
        variables,
        update: (_, { data }) => update(data),
        refetchQueries,
      });
      return result.data;
    },
  });

export const makeSubscription =
  ({ variables = {}, name = '' }) =>
  (type, query) => {
    let subscription = { unsubscribe: () => {} };
    return {
      subscribe(cb = () => {}) {
        subscription = cli.subscribe({ query, variables }).subscribe({
          next({ data }) {
            cb(data);
            // store.dispatch({ type, payload: data ? data[name] : {} });
          },
        });
      },
      unsubscribe() {
        return subscription.unsubscribe();
      },
    };
  };

export const makeActionCreator = (actionType) => (payload) => ({
  type: actionType,
  payload,
});

export const makeRequestReducer =
  ({
    types: [REQUEST, SUCCESS, FAIL],
    name,
    mutate = (state, res) => res,
    initialState = {},
    initialData = {},
    append = [],
  }) =>
  (
    state = { loading: false, error: '', data: initialData, ...initialState },
    action,
  ) => {
    let result;
    switch (action.type) {
      case REQUEST:
        result = { ...state, loading: true, error: '' };
        break;
      case SUCCESS:
        result = {
          ...state,
          loading: false,
          data: mutate(state, action.payload[name]),
        };
        break;
      case FAIL:
        result = { ...state, loading: false };
        break;
      default:
        result = state;
    }

    forEach(append, (a) => {
      result = a(result, action);
    });

    return result;
  };



// WEBPACK FOOTER //
// ./src/config/client.js